import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import LabelDesigner from './LabelDesigner';
import SimpleLabelDesigner from './SimpleLabelDesigner';
import KonvaLabelDesigner from './KonvaLabelDesigner';

const TestLabelDesigner = () => {
  const [designData, setDesignData] = useState(null);
  const [designerType, setDesignerType] = useState('konva'); // 'konva', 'simple', 'fpd'

  const handleDesignChange = (data) => {
    console.log('🎨 Design changed:', data);
    setDesignData(data);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      <main className="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg shadow-lg p-6">
          <div className="mb-6">
            <div className="flex items-center justify-between mb-4">
              <div>
                <h1 className="text-3xl font-bold text-gray-900 mb-2">
                  Test Label Designer
                </h1>
                <p className="text-gray-600">
                  Testa il designer per le etichette personalizzate dei liquori
                </p>
              </div>
              
              <div className="flex items-center space-x-4">
                <label className="flex items-center">
                  <input
                    type="radio"
                    checked={designerType === 'konva'}
                    onChange={() => setDesignerType('konva')}
                    className="mr-2"
                  />
                  🚀 KonvaJS Pro
                </label>
                <label className="flex items-center">
                  <input
                    type="radio"
                    checked={designerType === 'simple'}
                    onChange={() => setDesignerType('simple')}
                    className="mr-2"
                  />
                  📝 Fabric Semplice
                </label>
                <label className="flex items-center">
                  <input
                    type="radio"
                    checked={designerType === 'fpd'}
                    onChange={() => setDesignerType('fpd')}
                    className="mr-2"
                  />
                  ⚡ FPD Completo
                </label>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Designer Column */}
            <div className="lg:col-span-2">
              {designerType === 'konva' && (
                <KonvaLabelDesigner onDesignChange={handleDesignChange} />
              )}
              {designerType === 'simple' && (
                <SimpleLabelDesigner onDesignChange={handleDesignChange} />
              )}
              {designerType === 'fpd' && (
                <LabelDesigner onDesignChange={handleDesignChange} />
              )}
            </div>

            {/* Preview/Info Column */}
            <div className="space-y-6">
              {/* Design Preview */}
              {designData && (
                <div className="bg-gray-50 rounded-lg p-4">
                  <h4 className="font-semibold text-gray-900 mb-3">Anteprima Design</h4>
                  <div className="bg-white rounded border p-2 mb-3">
                    <img 
                      src={designData.imageDataURL} 
                      alt="Design Preview" 
                      className="w-full h-auto rounded"
                    />
                  </div>
                  <div className="text-xs text-gray-500">
                    Ultimo aggiornamento: {new Date(designData.timestamp).toLocaleTimeString()}
                  </div>
                </div>
              )}

              {/* Instructions */}
              <div className="bg-blue-50 rounded-lg p-4">
                <h4 className="font-semibold text-blue-900 mb-3">Come Usare</h4>
                <ul className="text-sm text-blue-800 space-y-2">
                  <li className="flex items-start">
                    <span className="mr-2">📝</span>
                    Aggiungi testo per il nome del liquore
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">🎨</span>
                    Cambia colori e stili
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">🖼️</span>
                    Carica immagini personalizzate
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">📐</span>
                    Ridimensiona e posiziona elementi
                  </li>
                </ul>
              </div>

              {/* Technical Info */}
              <div className="bg-gray-100 rounded-lg p-4">
                <h4 className="font-semibold text-gray-900 mb-3">Info Tecniche</h4>
                <div className="text-sm text-gray-700 space-y-2">
                  <div>
                    <strong>Libreria:</strong> Fancy Product Designer
                  </div>
                  <div>
                    <strong>Formato Export:</strong> PNG/JSON
                  </div>
                  <div>
                    <strong>Dimensioni:</strong> 400x300px
                  </div>
                  <div>
                    <strong>Stato:</strong> 
                    <span className="ml-1 text-green-600">
                      {designData ? '✅ Attivo' : '⏳ In attesa'}
                    </span>
                  </div>
                </div>
              </div>

              {/* Actions */}
              <div className="space-y-3">
                <button 
                  onClick={() => console.log('Design data:', designData)}
                  disabled={!designData}
                  className="w-full px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors"
                >
                  Salva Design
                </button>
                
                <button 
                  onClick={() => window.location.reload()}
                  className="w-full px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
                >
                  Reset Designer
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default TestLabelDesigner;